import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Pricing.css";

const TABS = [
    { key: "featured", label: "Featured" },
    // { key: "bundles", label: "Bundles" },
    { key: "website", label: "Website" },
    { key: "social", label: "Social Media" },
    // { key: "landing", label: "Landing Page" },
    // { key: "newsletter", label: "Newsletter" }
];

export default function Pricing() {
    const [activeTab, setActiveTab] = useState("featured");
    const [billing, setBilling] = useState("annual");
    const navigate = useNavigate();

    const getStarted = (planName) => navigate("/signup", { state: { selectedPlan: planName } });

    const tiers = [
        {
            name: "Starter Website",
            price: { annual: "14.99" },
            details: [
                "Beautiful Designs & Themes",
                "Basic Hosting",
                "Basic Support",
                "Secure/SSL Encrypted Website",
                "Basic SEO",
                "IDX Integration",
            ],
            popular: true,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Starter Website") }
        },
        {
            name: "Advanced Website",
            price: { annual: "49.99" },
            details: [
                "Beautiful Designs & Themes",
                "Premum Hosting",
                "Premium Support",
                "Secure/SSL Encrypted Website",
                "Enchanced SEO",
                "IDX Integration",
                "Monthly Blog Posts",
                "Analytics"
            ],
            popular: false,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Advanced Website") }
        },
        {
            name: "Professional Website",
            price: { annual: "199.99" },
            details: [
                "Beautiful Designs & Themes",
                "Premium Hosting",
                "One-to-One Support",
                "Secure/SSL Encrypted Website",
                "Premium SEO",
                "IDX Integration",
                "Customized Blog Posts",
                "Premium Analytics",
                "Custom made website design",
            ],
            note: "Min. 6 month contract",
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Professional Website") }
        }
    ];

    const socialMediaPlans = [
        {
            name: "Starter Socials",
            price: { annual: "39.99" },
            features: [
                "2 Posts/Month",
                "Facebook, Twitter/X",
                "Graphics",
                "Branded to your business",
                "Basic Analytics",
            ],
            popular: true,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Starter Socials (No video)") }
        },
        {
            name: "Advanced Socials",
            price: { annual: "79.99" },
            features: [
                "4 Posts/Month",
                "All Platforms",
                "Graphics & Video",
                "Branded to your business",
                "Basic Analytics",
                "Basic Community Engagement",
                "Monthly Reporting"
            ],
            popular: false,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Advanced Socials (Supports Video)") }
        },
        {
            name: "Professional Socials",
            price: { annual: "149.99" },
            features: [
                "8 Posts/Month",
                "All Platforms",
                "High Quality Graphics & Video",
                "Branded to your business",
                "Advanced Analytics",
                "Advanced Community Engagement",
                "Monthly Reporting",
                "Full Content Strategy",
                "Content Calendar"
            ],
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Professional Socials (Supports Video)") }
        }
    ];

    const landingPages = [
        {
            name: "Single Landing Page",
            price: { annual: "9.99" },
            features: [
                "One Landing Page",
                "Branded to your business",
                "Basic Hosting",
                "Basic Analytics",
            ],
            popular: true,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Single Landing Page") }
        },
        {
            name: "Team Landing Pages",
            price: { annual: "49.99" },
            features: [
                "Up to five Landing Pages",
                "Branded to your business",
                "Premium Hosting",
                "Premium Analytics",
            ],
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Team Landing Page") }
        }
    ];

    const newsletterPlans = [
        {
            title: "Growth Newsletter",
            price: { annual: "14.99" },
            features: [
                "Monthly Newsletter",
                "Basic Analytics",
                "Monthly Reporting"
            ],
            popular: true,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Growth Newsletter") }
        },
        {
            title: "Professional Newsletter",
            price: { annual: "29.99" },
            features: [
                "By-weekly Newsletter",
                "Access to new templates early",
                "Advanced Analytics",
                "A/B Testing",
                "White Labeling",
                "Monthly Reporting"
            ],
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Professional Newsletter") }
        }
    ];

    const bundles = [
        {
            name: "All-in-One Growth Bundle",
            price: { annual: "99.99" },
            desc: "Website + Social Media",
            features: [
                "Custom Website",
                "Full Social Media Management",
                "Two Landing Pages",
                // "Weekly Newsletters",
                "4 Social Posts/mo",
                "Branded Graphics & Video",
                "Advanced SEO",
                "IDX Integration",
                "Advanced Analytics",
                "Monthly Reporting",
                // "Two Blog Post/mo",
                "Priority Support"
            ],
            highlight: true,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("All-in-One Growth Bundle") }
        },
        {
            name: "Hosting Bundle",
            price: { annual: "19.99" },
            desc: "Website + Landing Page",
            features: [
                "One Website",
                "One Landing Page",
                "Branded to your business",
                "Beautiful Designs & Themes",
                "Secure/SSL Encrypted Websites",
                "Hosting",
                "Support",
                "SEO",
            ],
            popular: false,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Hosting Bundle") }
        },
        {
            name: "Socials Bundle",
            price: { annual: "19.99" },
            desc: "Social Media + Newsletter",
            features: [
                "2 Social Posts/mo",
                "Community Engagement",
                "Branded Graphics",
                "Monthly Newsletter",
                "Analytics"
            ],
            popular: true,
            button: { label: "Get Started", color: "primary", onClick: () => getStarted("Socials Bundle") }
        },
    ];

    // Round to nearest 0.49 or 0.99
    function roundPrice(amount) {
        const floor = Math.floor(amount);
        const decimal = amount - floor;
        if (decimal < 0.74) {
            return (floor + 0.49).toFixed(2);
        } else {
            return (floor + 0.99).toFixed(2);
        }
    }

    // Calculate monthly, 20% more than annual, rounded
    function renderPrice(priceObj) {
        let price;
        if (billing === "annual") {
            price = priceObj.annual;
        } else {
            // Monthly = annual * 1.2, rounded
            const annual = parseFloat(priceObj.annual);
            const monthlyRaw = annual * 1.2;
            price = roundPrice(monthlyRaw);
        }
        return (
            <span>
                <span className="pricing-card-price-main">${price}</span>
                <span className="pricing-card-price-term">/mo</span>
            </span>
        );
    }

    function renderWebsitePricing() {
        return (
            <div className="pricing-cards-row">
                {tiers.map((tier, idx) => (
                    <div className="pricing-card billing-card" key={idx}>
                        {tier.popular && (
                            <span className="pricing-popular-badge">Popular</span>
                        )}
                        <div className="pricing-card-header">{tier.name}</div>
                        <div className="pricing-card-price">{renderPrice(tier.price)}</div>
                        <ul className="pricing-card-features">
                            {tier.details.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                        {tier.note && <div className="pricing-card-note">{tier.note}</div>}
                        <button className={`pricing-card-btn ${tier.button.color}`} onClick={tier.button.onClick}>
                            {tier.button.label}
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    function renderSocialMediaPricing() {
        return (
            <div className="pricing-cards-row">
                {socialMediaPlans.map((plan, idx) => (
                    <div className="pricing-card billing-card" key={idx}>
                        {plan.popular && (
                            <span className="pricing-popular-badge">Popular</span>
                        )}
                        <div className="pricing-card-header">{plan.name}</div>
                        <div className="pricing-card-price">{renderPrice(plan.price)}</div>
                        <ul className="pricing-card-features">
                            {plan.features.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                        <button className={`pricing-card-btn ${plan.button.color}`} onClick={plan.button.onClick}>
                            {plan.button.label}
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    function renderNewsletterPricing() {
        return (
            <div className="pricing-cards-row">
                {newsletterPlans.map((plan, idx) => (
                    <div className="pricing-card billing-card" key={idx}>
                        {plan.popular && (
                            <span className="pricing-popular-badge">Popular</span>
                        )}
                        <div className="pricing-card-header">{plan.title}</div>
                        <div className="pricing-card-price">{renderPrice(plan.price)}</div>
                        <ul className="pricing-card-features">
                            {plan.features.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                        <button className={`pricing-card-btn ${plan.button.color}`} onClick={plan.button.onClick}>
                            {plan.button.label}
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    function renderLandingPages() {
        return (
            <div className="pricing-cards-row">
                {landingPages.map((plan, idx) => (
                    <div className="pricing-card billing-card" key={idx}>
                        {plan.popular && (
                            <span className="pricing-popular-badge">Popular</span>
                        )}
                        <div className="pricing-card-header">{plan.name}</div>
                        <div className="pricing-card-price">{renderPrice(plan.price)}</div>
                        <ul className="pricing-card-features">
                            {plan.features.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                        <button className={`pricing-card-btn ${plan.button.color}`} onClick={plan.button.onClick}>
                            {plan.button.label}
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    function renderBundles() {
        return (
            <div className="pricing-cards-row">
                {bundles.map((bundle, idx) => (
                    <div className={`pricing-card billing-card ${bundle.highlight ? "bundle-highlight" : ""}`} key={idx}>
                        {bundle.popular && (
                            <span className="pricing-popular-badge">Popular</span>
                        )}
                        <div className="pricing-card-header">{bundle.name}</div>
                        <div className="pricing-card-price">{renderPrice(bundle.price)}</div>
                        <div className="pricing-card-desc">{bundle.desc}</div>
                        <ul className="pricing-card-features">
                            {bundle.features.map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                        <button className={`pricing-card-btn ${bundle.button.color}`} onClick={bundle.button.onClick}>
                            {bundle.button.label}
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    // --- Add this function to render the Featured tab ---
    function renderFeatured() {
        // Find the relevant plans
        const starterWebsite = tiers.find(t => t.name === "Starter Website");
        const starterSocials = socialMediaPlans.find(s => s.name === "Starter Socials");
        const allInOneBundle = bundles.find(b => b.name === "All-in-One Growth Bundle");

        // Prepare a unified array for rendering in the requested order
        const featuredPlans = [
            {
                type: "website",
                ...starterWebsite
            },
            {
                type: "social",
                ...starterSocials
            },
            {
                type: "bundle",
                ...allInOneBundle
            }
        ];

        return (
            <div className="pricing-cards-row">
                {featuredPlans.map((plan, idx) => (
                    <div
                        className={`pricing-card billing-card${plan.highlight ? " bundle-highlight" : ""}`}
                        key={idx}
                    >
                        {plan.popular && (
                            <span className="pricing-popular-badge">Popular</span>
                        )}
                        <div className="pricing-card-header">{plan.name}</div>
                        <div className="pricing-card-price">{renderPrice(plan.price)}</div>
                        {plan.desc && <div className="pricing-card-desc">{plan.desc}</div>}
                        <ul className="pricing-card-features">
                            {(plan.details || plan.features).map((f, i) => <li key={i}>{f}</li>)}
                        </ul>
                        {plan.note && <div className="pricing-card-note">{plan.note}</div>}
                        <button className={`pricing-card-btn ${plan.button.color}`} onClick={plan.button.onClick}>
                            {plan.button.label}
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    // --- Brokerage Pricing Section ---
    function renderBrokeragePricing() {
        return (
            <div className="brokerage-pricing-section">
                <div className="brokerage-pricing-card">
                    <div className="brokerage-pricing-header">
                        <span className="brokerage-icon">🏢</span>
                        <span>Brokerage Solutions</span>
                    </div>
                    <div className="brokerage-pricing-body">
                        <div className="brokerage-pricing-title">Custom Pricing for Brokerages</div>
                        <div className="brokerage-pricing-desc">
                            Unlock exclusive features and tailored solutions for your entire brokerage.<br />
                            <strong>Website, social media, analytics, onboarding, and more.</strong>
                        </div>
                        <div className="brokerage-pricing-note">
                            <em>Contact us for a personalized quote and discover how we can empower your brokerage.</em>
                        </div>
                        <button
                            className="brokerage-pricing-btn"
                            onClick={() => navigate("/brokermessage", { state: { inquiryType: "brokerage" } })}
                        >
                            Contact Us for Pricing
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="billing-pricing-page">
            <nav className="billing-tabs">
                {TABS.map(tab => (
                    <button
                        key={tab.key}
                        className={`billing-tab${activeTab === tab.key ? " active" : ""}`}
                        onClick={() => setActiveTab(tab.key)}
                        data-tab={tab.key}
                    >
                        {tab.label}
                    </button>
                ))}
            </nav>

            <div className="pricing-billing-toggle-container" style={{ position: "relative" }}>
                <button
                    className={`pricing-billing-toggle-btn${billing === "annual" ? " selected" : ""}`}
                    onClick={() => setBilling("annual")}
                >
                    Annual
                    <span className="pricing-billing-save-badge-tilted">-20%</span>
                </button>
                <button
                    className={`pricing-billing-toggle-btn${billing === "monthly" ? " selected" : ""}`}
                    onClick={() => setBilling("monthly")}
                >
                    Monthly
                </button>
            </div>

            <div className={`billing-tab-content${billing === "annual" ? " annual-active" : ""}`}>
                {activeTab === "featured" && renderFeatured()}
                {activeTab === "website" && renderWebsitePricing()}
                {activeTab === "social" && renderSocialMediaPricing()}
                {activeTab === "newsletter" && renderNewsletterPricing()}
                {activeTab === "landing" && renderLandingPages()}
                {activeTab === "bundles" && renderBundles()}
            </div>
            {/* --- Add Brokerage Pricing Section below pricing cards --- */}
            {renderBrokeragePricing()}
        </div>
    );
}

// --- Add minimal CSS styles (suggested, place in Pricing.css) ---
// .brokerage-pricing-section { display: flex; justify-content: center; margin: 3rem 0 2rem 0; }
// .brokerage-pricing-card { background: #181c24; color: #fff; border-radius: 18px; box-shadow: 0 4px 32px rgba(0,0,0,0.12); max-width: 480px; width: 100%; padding: 2.5rem 2rem; text-align: center; }
// .brokerage-pricing-header { font-size: 1.5rem; font-weight: 700; margin-bottom: 1.2rem; display: flex; align-items: center; justify-content: center; gap: 0.7rem; }
// .brokerage-icon { font-size: 2.2rem; }
// .brokerage-pricing-title { font-size: 1.25rem; font-weight: 600; margin-bottom: 0.7rem; }
// .brokerage-pricing-desc { font-size: 1.05rem; margin-bottom: 1.1rem; }
// .brokerage-pricing-note { color: #b0b8c9; font-size: 0.98rem; margin-bottom: 1.5rem; }
// .brokerage-pricing-btn { background: linear-gradient(90deg, #4f8cff 0%, #2351a2 100%); color: #fff; border: none; border-radius: 8px; padding: 0.85rem 2.2rem; font-size: 1.08rem; font-weight: 600; cursor: pointer; transition: background 0.2s; }
// .brokerage-pricing-btn:hover { background: linear-gradient(90deg, #2351a2 0%, #4f8cff 100%); }
